<template>
    <div>
        <h3 class="mt-3">Cutoff</h3>

        <form novalidate @change="eventActivateUpdateFlag('Cutoff')">
            <div class="row mt-5">
                <div class="col-sm-10">

                    <cutoff-manager
                        :isCutoffActive.sync="getSelectedEvent.hasCutOff"
                        :selectedChannels.sync="getSelectedEvent.cutOffChannelsMain"
                        :selectedAgents.sync="getSelectedEvent.cutOffChannelsAgents"
                        :cutOffTime.sync="getSelectedEvent.cutOffTime"
                        :softCutOff.sync="getSelectedEvent.softCutOff"
                        @change="cutoffChanged()">
                    </cutoff-manager>

                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import cutoffManager from '@/components/inventory/products/components/cutoff/cutoffManager'
    import {mapGetters, mapActions} from 'vuex'
    
    export default {
        mixins: [],
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
            }
        },
        created: function() {
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent'
            ]),
        },
        methods: {
            cutoffChanged: function () {
                this.eventActivateUpdateFlag('Cutoff')
                this.isCutoffEdited = true
            }
        },
        components: {
            cutoffManager
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaCutoff.vue?1c225adc